'use client';

import { c as _c } from "react/compiler-runtime";
import { useAuth, useGetWatchlist } from '@morfi/backend-sdk-v2/client';
type WatchlistArgs = Parameters<typeof useGetWatchlist>[0];
type WatchlistOptions = Parameters<typeof useGetWatchlist>[1];
export function useAuthenticatedWatchlist(args, options) {
  const $ = _c(6);
  const {
    isAuthenticated
  } = useAuth();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["pubkeys"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== args) {
    t1 = {
      ...args,
      fields: t0
    };
    $[1] = args;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = isAuthenticated && options?.enabled !== false;
  let t3;
  if ($[3] !== options || $[4] !== t2) {
    t3 = {
      ...options,
      enabled: t2
    };
    $[3] = options;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return useGetWatchlist(t1, t3);
}